<template>
 

  <div id="example">
    <button style="background-color: rgb(33, 165, 250); border-radius: 5px; color: white; padding: 6px; border: 1px white solid;" @click="add_category">添加分类</button>
    <!-- <ul class="switch-list">
      <li class="switch-item" v-for="item in propList">
        <span>{{ item.name }}: </span>
        <zk-switch v-model="config[item.name]"></zk-switch>
      </li>
    </ul> -->
    <zk-table
      class="table"
      ref="table"
      sum-text="sum"
      index-text="序号"
      :data="category"
      :columns="columns"
      :stripe="config.stripe"
      :border="config.border"
      :show-header="config.showHeader"
      :show-summary="config.showSummary"
      :show-row-hover="config.showRowHover"
      :show-index="config.showIndex"
      :tree-type="config.treeType"
      :is-fold="config.isFold"
      :expand-type="config.expandType"
      :selection-type="config.selectionType"
      @tree-icon-click="review_children">
      <!-- <template slot="$expand" scope="scope">
        {{ `My name is ${scope.row.name},
           this rowIndex is ${scope.rowIndex}.`
         }}
      </template> -->
      <template slot="state" scope="scope">
        <!-- <zk-switch v-model="scope.row.state_bool"></zk-switch> -->
        <el-switch
            v-model="scope.row.state_bool"
            active-color="#13ce66"
            inactive-color="#A3A3A3"
            @change="switch_change(scope.row)">
          </el-switch>
        <!-- <zk-switch v-else-if="scope.row.state == 2" v-model="false"></zk-switch> -->
        <!-- {{ scope.row.likes.join(',') }} -->
      </template>
       <template slot="likes" scope="scope">
        <button style="background-color: rgb(33, 165, 250); border-radius: 5px; color: white; padding: 6px; border: 1px white solid;" @click="edit_category(scope.row)">编辑</button>
        <button style="margin-left: 20px; background-color: rgb(255, 127, 107); border-radius: 5px; color: white; padding: 6px; border: 1px white solid;" @click="handleDelete(scope.row)">删除</button>
        <!-- {{ scope.row.likes.join(',') }} -->
      </template>
    </zk-table>


    <!-- 添加分类 -->
    <!-- width="30%" -->
    <el-dialog
      :title="editCategory.id?'编辑分类':'新增分类'"
      :visible.sync="dialogVisible"
      
      :before-close="handleClose">
      <el-form :inline="true" :model="editCategory" class="demo-form-inline">
        <!-- <el-form-item label="分类名称">
          <el-input v-model="editCategory.name" placeholder="分类名称"></el-input>
        </el-form-item> -->
        <name-lang @lang_change="lang_change" :reset="dialogVisible" :edit_lan="editCategory.name"></name-lang>
        <el-form-item label="排序">
          <el-input v-model="editCategory.sort" placeholder="输入数字排序"></el-input>
        </el-form-item>
        <div></div>
        <el-form-item label="父级分类">
            <el-cascader
                class="cascader"
                v-model="selectedCategoryKeys"
                :options="select_category"
                :props="props"
                @change="parentCateChanged">
            </el-cascader>
        </el-form-item>
        <div></div>
        <el-form-item>
          <el-button type="primary" @click="editCategorySubmit">{{editCategory.id?'修改':'新增'}}</el-button>
        </el-form-item>
      </el-form>
      <!-- <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span> -->
    </el-dialog>
  </div>
</template>

<script>
  import ZkSwitch from '../components/Switch/Switch.vue';
  import NameLang from '../components/Lang/NameLang.vue';
import { shop_category_list, all_category_list, edit_category, delete_category} from '../api/api';
import { findNodeById } from '../utils';

export default {
  components: {
      ZkSwitch,
      NameLang
  },
  data() {
    return {
      dialogVisible:false,
      // arr: [],
      //lans json str.'{"1":"DDADA"}'
      // category_lans_str:'',
      tree_type:false,
      editCategory:{},
      selectedCategoryKeys:[],
      default_category:{
            value:0,
            id:0,
            name:'默认分类',//最顶层
            name_lang:'默认分类',//最顶
            label:'默认分类'//最顶层
      },
      config: {
          stripe: false,
          border: true,
          showHeader: true,
          showSummary: false,
          showRowHover: true,
          showIndex: true,
          treeType: true,
          isFold: true,
          expandType:false,
          selectionType: false,
        },
        category: [
          
        ],
        select_category:[],
        props: {
          checkStrictly: true, // 允许父节点单独选中
        },
        columns: [
          {
            label: '分类名称',
            width:'300px',
            prop: 'name_lang',
            // width: '400px',
          },
          {
            label: '是否启用',
            width:'100px',
            prop: 'state',
            type:'template',
            template:'state'
            // minWidth: '50px',
          },
          {
            label: '排序',
            width:'100px',
            prop: 'sort',
          },
          {
            label: '操作',
            prop: 'likes',
            width:'150px',
            // minWidth: '200px',
            type: 'template',
            template: 'likes',
          },
        ],

    };
  },


  mounted() {
    //   记载完毕后获取分类

    this.$nextTick(()=>{

      this.refresh_all_category_list()
      
    })
   
  },
  computed: {
  
      propList() {
        return Object.keys(this.config).map(item => ({
          name: item,
        }));
      },
  },
  methods: {
    refresh_all_category_list(){
      all_category_list()
      .then( res=>{
        console.log('category-list',res)
        this.category = res.tree
        this.select_category = [...res.tree]
        this.select_category.unshift(this.default_category)
        this.categorysKeyAddForEach(this.category)
      })
      .catch(err=>{

      })
    },
    async getChildren(v){
      const {list} = await shop_category_list(v.id)
      this.$set(v, 'children', list);
    },

    categorysKeyAddForEach(arr){
      arr.forEach(item=>{
        item.value = item.id;
        item.label = item.name_lang
        if(item.state == 1){
          item.state_bool = true;
        }else {
          item.state_bool = false;
        }
        if(item.children && item.children.length){
          this.categorysKeyAddForEach(item.children)
        }else if(item.children){
          Reflect.deleteProperty(item, 'children');
        }
      })
    },

    review_children(dom,detail){
      console.log('review_children',dom,detail)
      
    },
    add_category(){
      this.dialogVisible = true
      this.editCategory = {}
      this.selectedCategoryKeys = []
      // 待接入el-card
      // https://blog.csdn.net/acmman/article/details/123460173
      // https://element.eleme.cn/#/zh-CN/component/dialog
      // https://element.eleme.cn/#/zh-CN/component/cascader
    },
    edit_category(e){
      
      //根据e.pid查询categories,注意需要移除最后一个自己的e.id
      const current_category_keys = findNodeById(this.select_category,e.id).map(category=>category.id)

      this.selectedCategoryKeys = current_category_keys.slice(0, -1);
    
      this.editCategory = e

      this.dialogVisible = true
    
    },
    handleClose(){
      this.editCategory = {}
      this.selectedCategoryKeys = []
      this.dialogVisible = false
    },
    parentCateChanged(e){
      console.log('parentCateChanged',e,this.selectedCategoryKeys)
    },
    editCategorySubmit(e){
      console.log('editCategorySubmit',e,this.selectedCategoryKeys)
      if(!this.editCategory.name||!this.editCategory.name.length){
        this.$message({
          showClose: true,
          message: `缺少分类名称，至少要一种语言`,
          type:"error"
        })
        return;
      }
      if(!this.selectedCategoryKeys.length){

        this.$confirm(`未选择父分支，是否创建一级分支?`, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
        .then(()=>{
          this.okToCreateCategory(this.editCategory.name,0)
        })
        return;
      }
      const lastCategoryID = this.selectedCategoryKeys[this.selectedCategoryKeys.length-1];
      this.okToCreateCategory(this.editCategory.name,lastCategoryID)
    },

    okToCreateCategory(name,pid){
      console.log('okToCreateCategory',name,pid,this.editCategory)
      edit_category({id:this.editCategory.id,pid,name,sort:this.editCategory.sort,state:1})
      .then(res=>{
        this.dialogVisible = false
        this.$message({
            showClose: true,
            message: `${this.editCategory.id?'编辑成功':'添加成功'}`,
            type:"success"
        })

        this.refresh_all_category_list()
        this.selectedCategoryKeys = []
      })
      .catch(err=>{
        this.$message({
          showClose: true,
          message: err,
          type:"error"
        })
        this.selectedCategoryKeys = []
      })
    },
    lang_change(json_lans){
      console.log('lang_change2',json_lans)
      // this.category_lans_str = JSON.stringify(json_lans);
      this.editCategory.name = JSON.stringify(json_lans);
    },
    handleDelete(val) {
      // 弹窗确认框
      this.$confirm(`是否删除分支：${val.name_lang} ?${val.children?'  注意该分类下面还有子分类':''}`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          // 确定则发送删除请求
          //   获取id
          const { id } = val;
          delete_category(id)
          .then(res=>{
            this.$message({
              showClose: true,
              message: `删除成功`,
              type:"success"
            })
            this.refresh_all_category_list()
          })
          .catch(err=>{
            this.$message({
              showClose: true,
              message: err,
              type:"error"
            })
          })
        })
        .catch(() => {
          // 取消的时候什么都不做

        });
    },
    switch_change(e){
      console.log('switch_change',e)
      if(e.state_bool){
        e.state = 1
      }else{
        e.state = 2
      }

      edit_category(e)
      .then(res=>{
        
      })
      .catch(err=>{
        this.$message({
          showClose: true,
          message: err,
          type:"error"
        })
      })
    }
  },
};
</script>

<style lang="less">
.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
}
.table{
  margin-top: 10px;
}

* {
    margin: 0;
    padding: 0;
  }

  .switch-list {
    margin: 20px 0;
    list-style: none;
    overflow: hidden;
  }

  .switch-item {
    margin: 20px;
    float: left;
  }

  .cascader{
    width: 500px;
  }
</style>